<template>
  <div>
    <com-equ-search typeOfView="site" @search="handleSearch"> </com-equ-search>
    <div class="flex justify-end mb-15px">
      <el-button type="primary" @click="handleBatch('old')">绑定设备</el-button>
      <el-button type="primary" @click="handleBatch('new')">绑定新设备</el-button>
      <el-button type="primary" @click="handleReboot">重启设备</el-button>
      <el-button type="primary" @click="voiceSetting">语音设置</el-button>
      <el-button type="primary" @click="processedOtaUpgrade">OTA升级</el-button>
    </div>
    <com-equ-list
      :defaultParams="siteDefaultParams"
      typeOfView="site"
      ref="table"
    ></com-equ-list>
    <the-voice-dialog
      ref="voiceRef"
      @onSuccess="
        () => {
          $refs.table.init()
        }
      "
    />
  </div>
</template>

<script>
import { rebootEquApi } from '@/api/site'
import { siteOtaUpgradeApi } from '@/api/equ'

import theVoiceDialog from '../../components/the-voice-dialog'

export default {
  components: { theVoiceDialog },

  props: {
    siteDefaultParams: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      exportQuery: {},
    }
  },

  methods: {
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },

    handleBatch(val) {
      const param = {
        type: val,
      }
      this.$refs.table.handleBind(param)
    },

    // 重启设备
    handleReboot() {
      this.$confirm('是否确认重启全部设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const params = {
            refStore: this.siteDefaultParams.refStore,
          }
          const res = await rebootEquApi(params)
          if (res) {
            this.$message.success(res.desc)
            this.$refs.table.init()
          }
        })
        .catch(() => {})
    },

    voiceSetting() {
      this.$refs.voiceRef.open(this.siteDefaultParams.refStore)
    },

    processedOtaUpgrade() {
      this.$confirm('确定要让设备查询OTA升级吗? 若有新版本设备将启动更新程序', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(
        async () => {
          const params = {
            refStore: this.siteDefaultParams.refStore,
          }
          await siteOtaUpgradeApi(params)
          this.$message({
            type: 'success',
            message: '操作成功',
          })
        },
        () => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        }
      )
    },
  },
}
</script>
